/**
 * 页面标题映射配置
 * 将页面路由映射到对应的国际化标题键
 */

export default {
	// 主包页面
	'pages/guide/index': '加载中...',
	'pages/index/index': '首页',
	'pages/order_addcart/order_addcart': '购物车',
	'pages/user/index': '个人中心',
	'pages/dynamic/index': '动态',
	'pages/service/index': '技术服务',

	// extension 分包
	'pages/extension/customer_list/chat': '对话详情',
	'pages/extension/news_list/index': '资讯',
	'pages/extension/news_details/index': '__DYNAMIC_TITLE__',  // 文章详情页使用动态标题
	'pages/extension/news_details/newspc': '文章详情',

	// goods_cate 分包
	'pages/goods_cate/goods_cate': '商品分类',

	// dynamicPc 分包
	'pages/dynamicPc/index': '动态',

	// admin_article 分包
	'pages/admin_article/index': '文章管理',
	'pages/admin_article/edit': '发布新文章',

	// 其他页面映射
	'pages/open_web/index': '加载中...',
	'pages/interface/index': '连接设备',
	'pages/interface/operate': '操作界面',

	// sample 分包
	'pages/sample/index': '新建寄样',
	'pages/sample/details': '测试详情',

	// work_order 分包
	'pages/work_order/index': '提交工单',
	'pages/work_order/details': '工单详情',
	'pages/work_order/list': '工单列表',

	// pc_sample 分包
	'pages/pc_sample/index': '寄样测试',
	'pages/pc_sample/details': '测试详情',
	'pages/pc_sample/list': '测试列表',
	'pages/pc_sample/address': '添加地址',

	// admin_sample 分包
	'pages/admin_sample/index': '寄样测试',
	'pages/admin_sample/details': '测试详情',
	'pages/admin_sample/list': '测试列表',
	'pages/admin_sample/address': '添加地址',

	// app-download 分包
	'pages/app-download/index': '加载中...',

	// goods 分包
	'pages/goods/goods_list/index': '商品列表',
	'pages/goods/goods_search/index': '搜索商品',
	'pages/goods/order_pay_status/index': '支付成功',
	'pages/goods/admin_order_detail/index': '订单详情',
	'pages/goods/goods_comment_con/index': '商品评价',
	'pages/goods/goods_comment_con/pc': '商品评价',
	'pages/goods/goods_comment_con/lottery_comment': '订单评价',
	'pages/goods/goods_comment_list/index': '商品评分',
	'pages/goods/goods_details_store/index': '门店列表',
	'pages/goods/goods_logistics/index': '物流信息',
	'pages/goods/goods_return/index': '申请退货',
	'pages/goods/goods_return_list/index': '退货列表',
	'pages/goods/lottery/grids/index': '抽奖活动',
	'pages/goods/lottery/grids/record': '中奖记录',
	'pages/goods/order_confirm/index': '提交订单',
	'pages/goods/order_confirm/index_com': '提交订单',
	'pages/goods/order_confirm/index_com_pc': '提交订单',
	'pages/goods/order_confirm/index_pc': '提交订单',
	'pages/goods/order_details/pc': '订单详情',
	'pages/goods/order_details/index': '订单详情',
	'pages/goods/order_list/index': '我的订单',
	'pages/goods/order_refund_goods/index': '退回商品',
	'pages/goods/cashier/index': '收银台',
	'pages/goods/cashier/pc': '收银台',
	'pages/goods/cashier/apppay': '收银台',
	'pages/goods/cashier/app_paypal': 'PayPal',

	// goods_details 分包
	'pages/goods_details/index': '__DYNAMIC_TITLE__',  // 商品详情页使用动态标题
	'pages/goods_details/commentList': '问大家',

	// activity 分包
	'pages/activity/bargain/index': '砍价记录',
	'pages/activity/goods_bargain/index': '砍价列表',
	'pages/activity/goods_bargain_details/index': '砍价活动',
	'pages/activity/goods_combination/index': '拼团活动',
	'pages/activity/goods_combination_details/index': '拼团活动',
	'pages/activity/goods_combination_status/index': '拼团',
	'pages/activity/goods_seckill/index': '限时秒杀',
	'pages/activity/goods_seckill_details/index': '限时秒杀',
	'pages/activity/poster-poster/index': '砍价海报',
	'pages/activity/presell/index': '预售列表',
	'pages/activity/presell_details/index': '预售详情',

	// users 分包
	'pages/users/Auto_login/index': '加载中...',
	'pages/users/alipay_invoke/index': '支付提示',
	'pages/users/auth/index': '',
	'pages/users/binding_phone/index': '',
	'pages/users/login/index': '登录',
	'pages/users/message_center/index': '消息中心',
	'pages/users/message_center/messageDetail': '消息详情',
	'pages/users/payment_on_behalf/index': '好友代付',
	'pages/users/payment_on_behalf/pay_status': '代付成功',
	'pages/users/privacy/index': '隐私协议',
	'pages/users/promoter-list/index': '推广人列表',
	'pages/users/promoter-order/index': '推广人订单',
	'pages/users/promoter_rank/index': '推广人排行',
	'pages/users/retrievePassword/index': '忘记密码',
	'pages/users/scan_login/index': '授权登录',
	'pages/users/scan_user/index': '扫码授权登录',
	'pages/users/staff_list/index': '员工列表',
	'pages/users/user_address_list/index': '地址管理',
	'pages/users/user_address/index': '添加地址',
	'pages/users/user_bill/index': '账单明细',
	'pages/users/user_cash/index': '提现',
	'pages/users/user_coupon/index': '我的优惠券',
	'pages/users/user_cancellation/index': '注销协议',
	'pages/users/user_distribution_level/index': '分销等级',
	'pages/users/user_goods_collection/index': '收藏商品',
	'pages/users/user_info/index': '设置',
	'pages/users/user_integral/index': '积分详情',
	'pages/users/user_money/index': '我的账户',
	'pages/users/user_phone/index': '绑定手机',
	'pages/users/user_payment/index': '余额充值',
	'pages/users/user_pwd_edit/index': '修改密码',
	'pages/users/user_return_list/index': '退货列表',
	'pages/users/user_sgin/index': '签到',
	'pages/users/user_sgin_list/index': '签到记录',
	'pages/users/user_spread_code/index': '分销海报',
	'pages/users/user_spread_money/index': '佣金记录',
	'pages/users/user_spread_user/index': '我的推广',
	'pages/users/user_vip/index': '我的等级',
	'pages/users/user_vip_areer/index': '经验记录',
	'pages/users/user_get_coupon/index': '领取优惠券',
	'pages/users/visit_list/index': '浏览记录',
	'pages/users/user_invoice_form/index': '添加新发票',
	'pages/users/user_invoice_list/index': '发票管理',
	'pages/users/user_invoice_order/index': '发票详情',
	'pages/users/wechat_login/index': '',
	'pages/users/commission_rank/index': '佣金排行',
};